import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import i18n from '../i18n';
import { compose } from 'redux';
import { connect } from 'react-redux';
import TagTypessActions from '../redux/TagTypesRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';
import TagTypeDetails from '../components/tagTypesElements/TagTypeDetails';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class TagTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      isSaveAlert: false,
      // tagTypes page params
      tagTypesItemsPerPage: 10,
      tagTypesPageNumber: 0,
      tagTypesSearchValue: null,
      tagTypesSortDirection: 'ASC',
      // tagTypes details
      hideDetails: true,
      isNewTagType: false,
      tagTypeId: null,
      defaultRequirePinCode: -1,
      name: '',
      description: '',
      isUsageCounterLimitless: false,
      defaultFutureTimeValue: '',
      defaultActivateDelay: '',
      defaultCounterValue: '',
      status: '',
      // controller details
      controllerId: null,
      controllerName: '',
      tempControllerName: '',
      checkedDoors: [],
      isDoorsModalOpen: false,
      doorsItemsPerPage: 10,
      doorsPageNumber: 0,
      doorsSearchValue: null,
      // validation
      isUntouched: true,
    };
  }

  componentDidMount() {
    if (this.props.customerId) {
      this.sendGetTagTypesRequest();
    }
  }

  componentWillUnmount() {
    this.props.resetTagTypes();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customerId !== this.props.customerId) {
      this.props.resetTagTypes();
      this.resetTagTypeFormFields();
      if (this.props.customerId) {
        this.sendGetTagTypesRequest();
      }
    }
    if (prevProps.tagTypesIsLoading && !this.props.tagTypesIsLoading) {
      if (this.props.tagTypesSuccessMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.tagTypesSuccessMessage,
        });
      }
      if (this.props.tagTypesErrorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.tagTypesErrorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({ tagTypeId: this.props.createdId, isUntouched: true, isNewTagType: false });
      }
    }
  }

  //common methods

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  // tagTypes list table methods

  sendGetTagTypesRequest() {
    const pageParams = {
      items: this.state.tagTypesItemsPerPage,
      page: this.state.tagTypesPageNumber,
      value: this.state.tagTypesSearchValue,
      sort: this.state.tagTypesSortDirection,
    };
    this.props.getTagTypes(this.props.customerId, pageParams);
  }

  changeTagTypesItemsPerPage = (tagTypesItemsPerPage) => {
    this.setState({ tagTypesItemsPerPage, tagTypesPageNumber: 0 }, () => this.sendGetTagTypesRequest());
  };

  changeTagTypesPage = (tagTypesPageNumber) => {
    this.setState({ tagTypesPageNumber }, () => this.sendGetTagTypesRequest());
  };

  handleSearchTagType = (tagTypesSearchValue) => {
    this.setState({ tagTypesSearchValue, tagTypesPageNumber: 0 }, () => this.sendGetTagTypesRequest());
    this.resetTagTypeFormFields();
  };

  handleSortTagType = (tagTypesSortBy, tagTypesSortDirection) => {
    this.setState({ tagTypesSortDirection, tagTypesPageNumber: 0 }, () => this.sendGetTagTypesRequest());
    this.resetTagTypeFormFields();
  };

  handleSearchTagTypeKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchTagType(value);
    }
  };

  handleTagTypeDetailsFormKeyPress = () => {
    console.log('handleTagTypeDetailsFormKeyPress not implemented');
  };

  selectTagType = (tagType) => {
    this.resetTagTypeFormFields();
    let tagTypeId = tagType.tagTypeId ? tagType.tagTypeId : null,
      name = tagType.name,
      description = tagType.description,
      isUsageCounterLimitless = tagType.isUsageCounterLimitless,
      defaultFutureTimeValue = tagType.defaultFutureTimeValue === -100 ? '' : tagType.defaultFutureTimeValue,
      defaultActivateDelay = tagType.defaultActivateDelay === -100 ? '' : tagType.defaultActivateDelay,
      defaultCounterValue = tagType.defaultCounterValue === -100 ? '' : tagType.defaultCounterValue,
      status = tagType.status,
      defaultRequirePinCode = tagType.defaultRequirePinCode;
    this.setState({
      hideDetails: false,
      isNewTagType: false,
      tagTypeId,
      name,
      description,
      isUsageCounterLimitless,
      defaultFutureTimeValue,
      defaultActivateDelay,
      defaultCounterValue,
      status,
      defaultRequirePinCode,
    });
  };

  // tagType details form methods

  resetTagTypeFormFields = () => {
    this.setState({
      tagTypeId: null,
      name: '',
      defaultRequirePinCode: -1,
      description: '',
      isUsageCounterLimitless: false,
      defaultFutureTimeValue: '',
      defaultActivateDelay: '',
      defaultCounterValue: '',
      status: 1,
      isUntouched: true,
    });
  };

  handleAddTagType = () => {
    this.resetTagTypeFormFields();
    this.setState({ hideDetails: false, tagTypesSearchValue: null, isNewTagType: true });
  };

  handleSaveTagType = () => {
    const {
      tagTypeId,
      name,
      description,
      isUsageCounterLimitless,
      defaultFutureTimeValue,
      defaultActivateDelay,
      defaultCounterValue,
      defaultRequirePinCode,
      status,
    } = this.state;
    const parseNumber = (value) => {
      if (parseInt(value)) {
        return parseInt(value);
      } else {
        return -100;
      }
    };
    const tagTypeInfos = {
      name,
      description,
      isUsageCounterLimitless,
      defaultFutureTimeValue: parseNumber(defaultFutureTimeValue),
      defaultActivateDelay: parseNumber(defaultActivateDelay),
      defaultCounterValue: isUsageCounterLimitless ? -100 : parseNumber(defaultCounterValue),
      defaultRequirePinCode,
      status,
      customerId: this.props.customerId,
    };
    const editTagTypeInfos = {
      ...tagTypeInfos,
      tagTypeId,
    };
    const pageParams = {
      items: this.state.tagTypesItemsPerPage,
      page: this.state.tagTypesPageNumber,
      value: this.state.tagTypesSearchValue,
      sort: this.state.tagTypesSortDirection,
    };

    this.state.isNewTagType
      ? this.props.createTagType(tagTypeInfos, this.props.customerId, pageParams)
      : this.props.editTagType(editTagTypeInfos, this.props.customerId, pageParams);
  };

  openDeleteTagTypeAlert = () => {
    const tagTypeName = this.state.name;
    this.setState({
      isAlertDialogOpen: true,
      isSaveAlert: false,
      alertTitle: i18n.t('tagTypeManager_deleteTagType_confirm_title'),
      alertContentText: i18n.t('tagTypeManager_deleteTagType_confirm', {
        tagTypeName,
      }),
      alertConfirmAction: this.deleteTagType,
    });
  };

  deleteTagType = () => {
    const pageParams = {
      items: this.state.tagTypesItemsPerPage,
      page: this.state.tagTypesPageNumber,
      value: this.state.tagTypesSearchValue,
      sort: this.state.tagTypesSortDirection,
    };
    this.props.deleteTagType(this.state.tagTypeId, this.props.customerId, pageParams);
    this.resetTagTypeFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  handleTagTypeDetailsFormKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!this.state.tagTypesSearchValue) {
        return this.handleSaveTagType();
      }
    }
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const tagTypesData = cloneDeep(this.props.tagTypes); //this is necessary for table to work
    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t(this.state.isSaveAlert ? 'Global_discard' : 'Global_cancel')}
          confirmButtonText={t(this.state.isSaveAlert ? 'Global_save' : 'Global_delete')}
          onConfirm={this.state.alertConfirmAction}
          {...(this.state.isSaveAlert && {
            leftButtonRed: true,
            rightButtonBlue: true,
            leftButtonAction: this.discardControllerChanges,
          })}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />
        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={tagTypesData}
                noDataText={t('widgetActivateTag_tagType_no_tagType')}
                handleClick={(value) => this.selectTagType(value)}
                columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
                activeRowValue={this.state.tagTypeId}
                activeRowField={'tagTypeId'}
                handleSearch={this.handleSearchTagType}
                sortBy={'name'}
                sortDirection={this.state.tagTypesSortDirection}
                handleSort={this.handleSortTagType}
                searchPlaceholder={t('tagTypeManager_searchTagType')}
                itemsPerPage={this.state.tagTypesItemsPerPage}
                changeItemsPerPage={this.changeTagTypesItemsPerPage}
                totalElements={this.props.tagTypesTotalElements}
                page={this.state.tagTypesPageNumber}
                changePage={this.changeTagTypesPage}
                onKeyPress={this.handleSearchTagTypeKeyPress}
                // rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.tagTypesItemsPerPage}
                onSelect={this.changeTagTypesItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <TagTypeDetails
                // buttons
                add1ButtonText={t('tagTypeManager_addNewTagType')}
                onDeleteButtonClick={this.openDeleteTagTypeAlert}
                onAdd1ButtonClick={this.handleAddTagType}
                onSaveButtonClick={this.handleSaveTagType}
                isDeleteButtonDisabled={!this.state.tagTypeId || this.state.isNewTagType}
                saveButtonDisabled={false}
                // tagType details form
                onKeyPressFormSubmit={this.handleTagTypeDetailsFormKeyPress}
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                tagTypeId={this.state.tagTypeId}
                name={this.state.name}
                description={this.state.description}
                isUsageCounterLimitless={this.state.isUsageCounterLimitless}
                onChangeSwitch={(event) => this.setState({ isUsageCounterLimitless: event.target.checked })}
                defaultCounterValue={this.state.defaultCounterValue}
                defaultFutureTimeValue={this.state.defaultFutureTimeValue}
                defaultActivateDelay={this.state.defaultActivateDelay}
                // form and validations
                isUntouched={this.state.isUntouched}
                setUntouched={(value) => this.setState({ isUntouched: value })}
                // details table
                noDetailsTable
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    distributorId: state.auth.distributorId,
    tagTypes: state.tagTypes.tagTypes,
    tagTypesTotalElements: state.tagTypes.tagTypesTotalElements,
    createdId: state.tagTypes.createdId,
    tagTypesIsLoading: state.tagTypes.isLoading,
    tagTypesSuccessMessage: state.tagTypes.successMessage,
    tagTypesErrorMessage: state.tagTypes.errorMessage,
    // controllers: state.tagTypes.controllers,
    customerControllers: state.tags.customerControllers,
    customerControllersTotal: state.tags.customerControllersTotal,
  };
};

const mapDispatchToProps = (dispatch) => ({
  // tagTypes
  getTagTypes: (customerId, pageParams) => dispatch(TagTypessActions.getTagTypesRequest(customerId, pageParams)),
  createTagType: (tagTypeInfos, customerId, pageParams) =>
    dispatch(TagTypessActions.createTagTypeRequest(tagTypeInfos, customerId, pageParams)),
  editTagType: (tagTypeInfos, customerId, pageParams) =>
    dispatch(TagTypessActions.editTagTypeRequest(tagTypeInfos, customerId, pageParams)),
  deleteTagType: (tagTypeId, customerId, pageParams) =>
    dispatch(TagTypessActions.deleteTagTypeRequest(tagTypeId, customerId, pageParams)),
  // addControllerToTagType: (tagTypeId, data, customerId, distributorId) =>
  //   dispatch(TagTypessActions.addControllerToTagTypeRequest(tagTypeId, data, customerId, distributorId)),
  resetTagTypes: () => dispatch(TagTypessActions.resetTagTypes()),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(TagTypes);
